import React from 'react';
import { Routing, ArrowRight2 } from 'iconsax-react';
import LinkButton from '@core/components/linkbutton/LinkButton';
import classes from './CareerBanner.module.scss';

const CareerBanner = () => {
    return (
        <div className={classes['career-banner']}>
            <h3>
                <Routing size={20} color="#4ecdc4" variant="TwoTone" />
                Your Personalized Path to Career Success
            </h3>
            <LinkButton kind='simple' to="/profile/user-info" className={classes['view-link']}>
                View Suggestion page
                <ArrowRight2 size={18} />
            </LinkButton>
        </div>
    );
};

export default CareerBanner;
